const WIDGET_COOKIE_NAME = 'amlbot.w.init';

interface WidgetUser {
  username: string;
  externalId: string;
}

export { WIDGET_COOKIE_NAME };
export type { WidgetUser };
